import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {OfferService} from './offer.service';
import {Breadcrumb} from '../../../model/breadcrumb';
import {ComponentBase} from '../../common/ComponentBase';
import {Meta, MetaDefinition} from '@angular/platform-browser';
import {MetaData} from '../../../model/meta-data';
import isNil from 'lodash-es/isNil';
import isEmpty from 'lodash-es/isEmpty';
import each from 'lodash-es/each';
import {environment} from '../../../../environments/environment';
import {ConstantService} from '../../../services/constant.service';
import {DataService} from '../../../../shared/shared-data.service';
import {setTimeout$} from "../../../services/utils";


@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferComponent extends ComponentBase implements OnInit, OnDestroy {
  public text: string;
  public name: string;
  public type: string;
  public parents: any;
  public offer: any;
  public metaData: MetaData;

  paths: Array<Breadcrumb> = [];
  flights: any;

  constructor(private route: ActivatedRoute, private offerService: OfferService, private constantService: ConstantService,
              private meta: Meta, public router: Router, private dataService: DataService) {
    super();
  }

  ngOnInit() {
    this.route.params.subscribe(res => {

      this.offerService.getByName(res.deal ? res.deal : 'Flights').subscribe(
        data => {
          this.offer = data;
            this.text = this.offer ? this.prepare(this.offer.content) : '';


          if (this.offer) {
            this.type = this.offer.customPageType;
            this.name = this.offer.name;
            this.metaData = {
              title: this.offer.metaTitle,
              description: this.offer.metaDescription,
              keywords: this.offer.metaKeywords
            };

            switch(this.type) {
              case 'AIRLINE':
                this.constantService.setConstant('_searchBlockHeader', this.name + ' Business Class Flights');
                break;
              case 'AIRLINES':
                this.constantService.setConstant('_searchBlockHeader', 'Find Cheap International Flight Deals at Wholesale Flights');
                break;
              case 'FLIGHTS':
                this.constantService.setConstant('_searchBlockHeader', 'International Business Class Flights');
                break;
              default:
                this.constantService.setConstant('_searchBlockHeader', 'Business Class Flights to ' + (isNil(this.name) || isEmpty(this.name)? this.name : this.name.replace('-', ' ')));
                break;
            }

            if (isNil(this.route.snapshot.queryParams['ArrivalCity']) && this.type === 'CITY') {
              setTimeout$(() => {this.dataService.sendData({type: 'autoFillTo', data: this.name})}, 0);
            }

            this.setMeta();
            this.loadBreadcrumbs();
            this.loadFlights();
          }
        },
        error => {
          console.error('Failed to load page content /n', error);
        }
      );
    });
  }

  ngOnDestroy() {
    this.constantService.setConstant('_searchBlockHeader', null);
  }

  followRoute(event) {event.preventDefault();
    const direction = event.target.getAttribute('direction');
    if (direction) {
      let routerLink = '/';
      if (this.type !== 'AIRLINES' && this.type !== 'AIRLINE') {
          routerLink = this.buildLink(direction, this.isBusinessLand);
      } else {
        routerLink = this.buildAirlineLink(direction, this.isBusinessLand);
      }
      this.router.navigate([routerLink]);

    }
  }

  setMeta() {
    const metaTags: MetaDefinition[] = [
      {
        name: 'title',
        content: this.metaData.title
      },
      {
        name: 'keywords',
        content: this.metaData.keywords
      },
      {
        name: 'description',
        content: this.metaData.description
      }
    ];
    const self = this;
    each(metaTags, tag => {
      self.meta.updateTag(tag);
    });
  }

  private prepare(content: string) : string {
    return content
      .replace(new RegExp('%%cdnPath%%', 'g'), environment.cdnPath)
      .replace(new RegExp('Business', 'g'), this.landingClass)
      .replace(new RegExp('business', 'g'), this.landingClass.toLowerCase())
      .replace(new RegExp('first-', 'g'), 'business-')
      .replace(new RegExp('/first/', 'g'), '/business/');
  }

  private loadFlights(): void {
    this.offerService.getChildren(this.offer.id).subscribe(
      response => {
        if (this.offer.customPageType !== 'COUNTRY') {
          this.flights = response;

          if (this.flights && this.flights.length > 0) {
            for (let j = 0; j < this.flights.length; j++) {
              this.offerService.getChildren(this.flights[j].id).subscribe(
                children => {this.flights[j].children = children; },
                error => { console.error('Failed to load page children /n', error); }
              );
            }
          }
        } else {
          this.offer.children = response;
          this.flights = [this.offer];
        }
      },
      error => {
        console.error('Failed to load page children /n', error);
      });
  }

  private loadBreadcrumbs(): void {
    this.offerService.getParentNames(this.offer.name).subscribe(
      response => {
        this.parents = response;
        this.paths = [];
        if (this.isBusinessLand) {
          this.paths.push(new Breadcrumb('Home', '/home'));
        } else {
          this.paths.push(new Breadcrumb('Home', '/first-class'));
        }
        if (this.parents) {
          for (let i = this.parents.length - 1; i >= 0; i--) {
            const link =  super.buildLink(this.parents[i], this.isBusinessLand);
            this.paths.push(new Breadcrumb(super.splitAndCapitalize(this.parents[i]), link));
          }
        }
        this.paths.push(new Breadcrumb(super.splitAndCapitalize(this.name), undefined));
      },
      error => {console.error('Failed to load page parents /n', error); }
    );
  }

  get showDefaultForm(): boolean {
    return !this.router.url.includes('(s:a)') && !this.router.url.includes('(s:b)') && !this.router.url.includes('(s:c)');
  }

  get isBusinessLand(): boolean {
    return this.landingClass === 'First' ? false : true;
  }

  get landingClass() {
    return isNil(this.router) || isNil(this.router.url) || !this.router.url.includes('first-class') ? 'Business' : 'First';
  }

  get isCutContent(): boolean {
    return this.router && this.router.url.includes('all-business-class');
  }
}
